/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import SocialButton from 'app/components/common/SocialButton.jsx';
import ToggleControl from 'app/components/common/ToggleControl.jsx';
import RouteDetailSocials from 'app/components/RouteList/RouteDetailSocials.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import RouteDetailModule from 'app/mixins/RouteDetailModule.jsx';
import SubscriptionModule from 'app/mixins/SubscriptionModule.js';
import DeleteModal from 'app/components/common/DeleteModal.jsx';
import ConfirmModal from 'app/components/common/ConfirmModal.jsx';
import * as _ from 'underscore';
import { Breakpoint } from 'react-socks';
import AccordionControl from 'app/components/common/AccordionControl.jsx';
import { Link } from 'react-router-dom';

class AdvancedRouteItemDetail extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			mobileFeedsVisible: false
		};

		this.createNewFeed = this.createNewFeed.bind(this);
		this.toggleFeedActive = this.toggleFeedActive.bind(this);
		this.editInput = this.editInput.bind(this);
		this.editRouteSettings = this.editRouteSettings.bind(this);
		this.deleteRoute = this.deleteRoute.bind(this);
		this.viewInput = this.viewInput.bind(this);
		this.refreshInput = this.refreshInput.bind(this);
		this.viewHistory = this.viewHistory.bind(this);
		this.toggleMobileFeeds = this.toggleMobileFeeds.bind(this);

	}

	componentDidMount() {
		// if (mixpanel) {
		// 	mixpanel.track('Route Detail View', {
		// 		viewType: 'advanced'
		// 	});
		// }
	}

	createNewFeed(e){

		let constants = this.props.app.config.constants,
			confirm = () => {
				this.props.closeAllModals();
			},
			confirmInputs = (
				<ConfirmModal
					modalCopy={"Twitter sources may not be mixed with other types of sources."}
					confirmAction={confirm}
					closeAction={confirm}
					confirmLabel="OK"
					showCancel={false}/>
			);

		if (this.props.route.inputs.length) {
			for (var i = 0; i < this.props.route.inputs.length; ++i) {
				if (this.props.route.inputs[i].type == constants.INPUT_TYPE_TWITTER) {
					this.props.addModal(confirmInputs);
					return;
				}
			}
		}

		e.preventDefault();

		if (this.props.user.perms.resources.inputsAvailable == 0) {
			this.props.showUpgradeModal(this.props.closeAllModals, 'inputs', null, 'automate_feeddetail');
		} else {
			this.props.router.navigate('/share/automate/detail/' + this.props.route.id + '/input/new');
		}

	}

	toggleFeedActive(e) {

		let id = e.currentTarget.dataset.id,
			toggleState = (e.currentTarget.dataset.togglestate === 'true') ? 0 : 1,
			constants = this.props.app.config.constants,
			canActivate = true;

		if (toggleState) {
			if (this.props.user.perms.resources.inputsAvailable == 0) {
				this.props.showUpgradeModal(this.props.closeAllModals, 'inputs', null, 'automate_feeddetail');
			} else {
				let inputs = this.props.route.inputs;
				for (let i = 0; i < inputs.length; ++i) {
					if ([constants.INPUT_TYPE_TWITTER, constants.INPUT_TYPE_INSTAGRAM, constants.INPUT_TYPE_INSTAGRAM_BUSINESS].indexOf(parseInt(inputs[i].type)) !== -1)
					{
						if (inputs[i].sysActionFlag) {
							canActivate = false;
						}
					}
				}
				if (canActivate) {
					this.props.startReactivation(id);
				} else {
					this.props.setDetailError('Reconnect your feed before activating it');
				}
			}
		} else {
			// deactivate feed instead
			let inputs = this.props.route.inputs;
			for (let i = 0; i < inputs.length; ++i) {
				if (inputs[i].id == id) {
					let input = _.clone(inputs[i]);
					input.activeFlag = 0;
					this.props.updateInput(input);
					break;
				}
			}
		}

	}

	editInput() {

		if (this.props.route.inputs.length) {
			this.props.router.navigate('/share/automate/detail/' + this.props.route.id + '/input/' + this.props.route.inputs[0].id);
		}

	}

	editRouteSettings() {

		this.props.router.navigate('/share/automate/settings/' + this.props.route.id);

	}

	deleteRoute(e) {

		let cancelAction = () => {
				this.props.closeAllModals();
			},
			confirmAction = (e) => {
				e.preventDefault();
				this.props.deleteRoute(this.props.route.id);
				this.props.closeAllModals();
				// page redirect handled by Automate.jsx _onRouteChange
			},
			modal = (
				<DeleteModal
					modalCopy="Are you sure you want to remove this route?"
					cancelAction={cancelAction}
					confirmAction={confirmAction} />
			);

		this.props.addModal(modal);

	}

	viewInput(e) {
  	    let constants = this.props.app.config.constants,
			type = e.currentTarget.dataset.type,
			url = e.currentTarget.dataset.resource,
			input = null,
			cb = '';

		input = this.props.route.inputs.find(({resource}) => {
			return resource === url;
		});
		if (input.useCachebuster !== undefined && input.useCachebuster === true) {
			cb = '&cb=1';
		}

		if (parseInt(type, 10) === constants.INPUT_TYPE_FEED) {
			url = '/feedPreview.php?url=' + encodeURIComponent(url) + cb;
		}



		let win = window.open(url, "_blank");
		if (win) {
			win.focus();
		}

	}

	refreshInput(e) {
		let inputId = e.currentTarget.dataset.id;
		this.props.inputRefreshHandler(inputId);
	}

	viewHistory(e) {
		let inputId = e.currentTarget.dataset.id;
		this.props.router.navigate('/share/automate/detail/' + this.props.route.id + '/input/' + inputId + '/status');
	}

	toggleMobileFeeds(e) {
		e.preventDefault();

		this.setState({
			mobileFeedsVisible: !this.state.mobileFeedsVisible
		});

	}

	render() {
		let statusBlock = "",
			feedLabel = "",
			activeFlag = (parseInt(this.props.route.activeFlag, 10) !== 0) ? true : false,
			detailBlock = null,
			feedList = null,
			mobileFeedDisplay = null,
			listToggle = null,
			toggleClass = '';

		if (this.props.route.id === undefined) {
			return null;
		}

		statusBlock = this.props.generateDetailStatusBlock.apply(this, []);

		feedLabel = " Feeds";
		if (this.props.route.inputs.length === 1) {
			feedLabel = " Feed";
		}
		feedLabel = this.props.route.inputs.length + feedLabel;

		feedList = (
			<ul className="detail-list">
				{this.props.route.inputs.map((input, i) => {
					let Icon = IconFactory[ConstantMixin.getIconIndexByCode(input.type)],
						statusIcon = <i className="fa fa-cog"></i>,
						resource = input.resource,
						inactive = false,
						constants = this.props.app.config.constants,
						toggleActive = input.activeFlag,
						toggleClass = 'inline small';

					if (input.subtype) {
						Icon = IconFactory[ConstantMixin.getIconIndexByCode(input.subtype)];
					}

					if (parseInt(input.postFlag, 10) === constants.POST_QUEUE) {
						switch (parseInt(input.type, 10)) {
							case constants.INPUT_TYPE_FEED:
								Icon = IconFactory.feedQueue;
								if (input.subtype && parseInt(input.subtype, 10) === constants.INPUT_SUBTYPE_PINTEREST) {
									Icon = IconFactory.pinterestQueue;
								}
								break;

							case constants.INPUT_TYPE_TWITTER:
								Icon = IconFactory.twitterQueue;
								break;

							case constants.INPUT_TYPE_INSTAGRAM:
							case constants.INPUT_TYPE_INSTAGRAM_BUSINESS:
								Icon = IconFactory.instagramQueue;
								break;
						}
					}

					if (parseInt(input.activeFlag, 10) === 0 || parseInt(this.props.route.activeFlag, 10) === 0) {
						inactive = true;
						if (parseInt(this.props.route.activeFlag, 10) === 0) {
							toggleClass += " route-inactive";
						}
					}

					// TODO: display error status when we need to

					if (parseInt(input.type) === this.props.app.config.constants.INPUT_TYPE_EMAIL) {
						return null;
					}

					let warning = null;
					if (input.sysActionFlag !== undefined && input.sysActionFlag === true) {
						warning = (
							<div className="status-action"
								alt="Reconnect Input"
								title="Reconnect Input"
								onClick={this.props.reauthorizeInput}
								data-id={input.id}
								data-serviceid={input.type}
								role="button"
								aria-label="reconnect input">
								<i className="fa fa-warning sys-action"></i>
							</div>
						);
					}

					return(
						<li className="list-item feed" key={i}>
							<div className="feed-list-label">
								<div className="feed-list-icon">
									<Icon inactive={inactive} round={true} small={true}/>
								</div>
								<Link to={'/share/automate/detail/' + this.props.route.id + '/input/' + input.id}>{input.name}</Link>
							</div>
							<div className="feed-list-status">
								{warning}
								<ToggleControl
									active={toggleActive}
									noLabel={true}
									callback={this.toggleFeedActive}
									toggleClass={toggleClass}
									data-id={input.id}/>

								<div className="status-action" alt="Preview feed" title="Preview feed" onClick={this.viewInput} data-type={input.type} data-resource={input.resource} role="button" aria-label="Preview">
									<i className="fa fa-external-link"></i>
								</div>
								<div className="status-action" alt="Check for updates" title="Check for updates" onClick={this.refreshInput} data-id={input.id} role="button" aria-label="check for updates">
									<i className="fa fa-refresh"></i>
								</div>
								<div className="status-action" alt="Check for updates" title="View feed history" onClick={this.viewHistory} data-id={input.id} role="button" aria-label="view history">
									<i className="fa fa-history"></i>
								</div>
								<Link to={'/share/automate/detail/' + this.props.route.id + '/input/' + input.id} className="status-action">{statusIcon}</Link>
							</div>
						</li>
					);
				})}
			</ul>
		);

		if (this.props.route.inputs.length > 3) {
			listToggle = (
				<div className="feed-mobile-toggle" onClick={this.toggleMobileFeeds} role='switch' aria-label="show feeds">
					{(this.state.mobileFeedsVisible) ? (<i className="fa fa-minus"/>) : (<i className="fa fa-plus"/>)}
					{(this.state.mobileFeedsVisible) ? 'Show Fewer Feeds' : 'Show More Feeds'}
				</div>
			);
		}

		if (this.state.mobileFeedsVisible) {
			toggleClass = "extended";
		}

		if (this.props.reactivating) {
			if (this.props.reactivatingInput) {
				detailBlock = this.props.getReactivateBlock('input');
			} else {
				detailBlock = this.props.getReactivateBlock('route');
			}
		} else {
			detailBlock = (
				<div>
					<div className="detail-block feed">
						<Breakpoint mobile only>
							<div className="add-social-mobile" onClick={this.createNewFeed} role="button" aria-label="add feed">
								<div className="social-gutter-button">
									<span className="gutter-label">
										<i className="fa fa-plus-square"></i>Add Feed
									</span>
								</div>
							</div>
							<div className={"detail-list-wrapper feed mobile " + toggleClass}>
								{feedList}
							</div>
							{listToggle}
						</Breakpoint>
						<Breakpoint desktop only>
							<div className="detail-list-header feed">
								<div className="action-links">
									<a href="#" onClick={this.createNewFeed} className="action-link">Add Feed</a>
								</div>
								<div className="status-label">
									{feedLabel}
								</div>
							</div>
							<div className="detail-list-wrapper feed">
								{feedList}
							</div>
						</Breakpoint>
					</div>
					<RouteDetailSocials
						{...this.props}
						route={this.props.route}
						routeId={this.props.route.id}
						routeActive={activeFlag}
						outputs={this.props.route.outputs}
						outputConfigHandler={this.configureOutput}
						recordPath={this.props.recordPath} />
				</div>
			);
		}


		return (
			<div>
				<div className="detail-controls">
					<div className="detail-toggle">
						<ToggleControl active={activeFlag} callback={this.props.activeRouteToggleClick}/>
					</div>
					<div className="detail-buttons">
						<div className="detail-button" onClick={this.editRouteSettings} role="button" aria-label="settings">
							<div className="button-icon">
								<i className="fa fa-pencil"></i>
							</div>
							<div className="button-label">
								Settings
							</div>
						</div>
						<div className="detail-button" onClick={this.deleteRoute} role="button" aria-label="delete">
							<div className="button-icon">
								<i className="fa fa-trash"></i>
							</div>
							<div className="button-label">
								Delete
							</div>
						</div>
					</div>
				</div>
				{statusBlock}
				{detailBlock}
			</div>
		);
	}
};

AdvancedRouteItemDetail.displayName = "AdvancedRouteItemDetail";

AdvancedRouteItemDetail.propTypes = {
	route: PropTypes.object,
	newRouteInfo: PropTypes.object,
	routeViewType: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	messages: PropTypes.array,
	errorCount: PropTypes.number,
	recordPath: PropTypes.func,
	inputRefreshHandler: PropTypes.func,
	trialEligible: PropTypes.bool
};

AdvancedRouteItemDetail.defaultProps = {
	route: {},
	newRouteInfo: {},
	routeViewType: 0,
	messages: [],
	errorCount: 0,
	recordPath: null,
	inputRefreshHandler: null,
};

export default RouteDetailModule(AdvancedRouteItemDetail);
